import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {

  switch (action.type) {

    case Types.REPORT_MODULE_DATA:
      return {
        ...state,
        reportModuleList: action.data,
      }

    case Types.REPORT_MODULE_ERR:
      return {
        ...state,
        reportModuleErr: action.err,
      }

    case Types.REPORT_MODULE_ADD:
      state.reportModuleList.push(action.data)
      return {
        ...state,
      }
    ///////////////////////////////////////////
    case Types.GROUP_DATA:
      return {
        ...state,
        groupList: action.data,
      }
    case Types.GROUP_ID:
      return {
        ...state,
        groupId: action.data,
      }

    case Types.GROUP_ERR:
      return {
        ...state,
        groupErr: action.err,
      }

    case Types.GROUP_ADD:
      state.groupList.push(action.data)
      return {
        ...state,
      }
    case Types.UPDATE_PORTAL_GROUP_DATA:
      const selectedGroupIndex = state.groupList.find((oneGroup) => { return oneGroup.id === action.id })
      const existGroupList = state.groupList
      if (selectedGroupIndex >= 0) {
        existGroupList[selectedGroupIndex] = { ...existGroupList[selectedGroupIndex], ...action.payload }
        state.groupList = existGroupList
      }
      return {...state}
    ///////////////////////////////////////////
    case Types.REQ_TYPE_DATA:
      return {
        ...state,
        reqTypeList: action.data,
      }
    case Types.REQ_TYPE_ERR:
      return {
        ...state,
        reqTypeErr: action.err,
      }

    case Types.P_COUNTRY_DATA:
      return {
        ...state,
        countryList: action.data,
      }
    case Types.P_COUNTRY_ERR:
      return {
        ...state,
        countryErr: action.err,
      }

    case Types.SITE_DATA:
      return {
        ...state,
        siteList: action.data,
      }

    case Types.SITE_ERR:
      return {
        ...state,
        siteErr: action.err,
      }
    default:
      return state;
  }
};
